import React, { ReactNode, useContext } from 'react';
import styled from 'styled-components';

import { LayoutContext } from '../../contexts/LayoutContext';

type Props = {
  children?: ReactNode;
};

export interface ContainerProps {
  collapsed: boolean;
}

const Body = ({ children }: Props) => {
  const { collapsed } = useContext(LayoutContext);
  return <Container collapsed={collapsed}>{children}</Container>;
};

export default Body;
const Container = styled.div<ContainerProps>`
  background: #fff;
  /* width: 100%; */
  padding: 2rem;
  padding-left: ${({ collapsed }) => (collapsed ? '100px' : '324px')};
  padding-top: 150px;
  min-height: 100vh;
  transition: padding-left 0.3s ease-out;
`;
